import { NavLink } from 'react-router-dom';
import { t } from '../lib/i18n';

// "My learning" chrome shared by My courses / Wishlist / Purchase history / Points
// (s134 redesign): full-width dark band with the page title and underlined
// tabs, then the page body in the standard 1200px column. The shell renders
// these routes full-bleed (PublicShell `fullBleed`).
const TABS = [
  ['/my/courses', 'My courses'],
  ['/my/wishlist', 'Wishlist'],
  ['/my/purchases', 'Purchase history'],
  ['/my/points', 'Points'],
];

export default function MyLearningShell({ children }) {
  return (
    <div className="min-h-full bg-lms-surface">
      <section className="bg-lms-band">
        <div className="mx-auto flex max-w-[1248px] flex-col gap-7 px-6 pt-9">
          <h1 className="text-[34px] font-bold leading-tight text-lms-band-text">{t('My learning')}</h1>
          <nav aria-label={t('My learning')} className="flex flex-wrap gap-x-7">
            {TABS.map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `border-b-4 pb-3 text-[15px] font-bold ${
                    isActive
                      ? 'border-lms-band-text text-lms-band-text'
                      : 'border-transparent text-lms-band-muted hover:text-lms-band-text'
                  }`
                }
              >
                {t(label)}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
      <div className="mx-auto max-w-[1248px] px-6 pb-12 pt-7">{children}</div>
    </div>
  );
}
